import type {
  Resource,
  WithResourcesPropsWithOptionalErrorT,
  WithResourcesArrayPropsWithOptionalErrorT,
} from '@freckle/educator-entities/ts/common/components/with-resources'
import {
  WithResourcesInternal,
  WithResourcesArrayInternal,
} from '@freckle/educator-entities/ts/common/components/with-resources'
import {Routes} from '@freckle/classroom/ts/common/routers/routes'
import {NavigateUnlessChromeless} from '@freckle/classroom/ts/hooks/chromeless/navigate-unless-chromeless'

export function WithResources<T extends Resource>({
  resources,
  render,
  error = (error: Error) => {
    return <NavigateUnlessChromeless error={error} route={Routes.dashboard()} />
  },
}: WithResourcesPropsWithOptionalErrorT<T>) {
  return WithResourcesInternal({resources, render, error})
}

export function WithResourcesArray<T extends Resource>({
  resources,
  render,
  error = (error: Error) => {
    return <NavigateUnlessChromeless error={error} route={Routes.dashboard()} />
  },
}: WithResourcesArrayPropsWithOptionalErrorT<T>) {
  return WithResourcesArrayInternal({resources, render, error})
}
